const ITEMS = [
    "NO LOW BRIDGES",
    "LIVE WEIGH STATION ALERTS",
    "DIESEL SAVINGS",
    "100% TRUCK-LEGAL ROUTES",
    "OVER-THE-ROAD FREEDOM",
    "NO DEAD-END U-TURNS",
    "HAMMER DOWN",
];

export default function Marquee() {
    const doubled = [...ITEMS, ...ITEMS];
    return (
        <div
            data-testid="marquee-strip"
            className="overflow-hidden border-y-2 border-[#0E0D0C] bg-[#E5A93C] py-3"
        >
            <div className="marquee-track flex w-max items-center">
                {doubled.map((t, i) => (
                    <span key={i} className="flex items-center">
                        <span className="font-display px-8 text-2xl tracking-widest text-[#161413]">
                            {t}
                        </span>
                        <span className="text-xl text-[#D32F2F]">★</span>
                    </span>
                ))}
            </div>
        </div>
    );
}
